module.exports = __webpack_public_path__ + "static/media/web-black-circle.56340060.svg";